module.exports = __webpack_public_path__ + "img/freespin2_multiplier6.d1c09195.png";